<template lang="pug">
.input-wrapper
  label(v-show="label" :for="label") {{ label }}
  textarea(
    name=""
    id=""
    cols="30"
    rows="4"
    :value="value"
    v-bind="$attrs"
    v-on="{...$listeners, input: (e) => $emit('input', e.target.value)}")
</template>

<script>
export default {
  name: 'RomatchTextarea',
  props: {
    label: String,
    value: [String, Number],
  },
}
</script>

<style scoped lang="stylus">
@import '~@/assets/_forms.styl'

.input-wrapper
  input-wrapper()
</style>
